import script from "./TPS.vue?vue&type=script&setup=true&lang=ts"
export * from "./TPS.vue?vue&type=script&setup=true&lang=ts"

import "./TPS.vue?vue&type=style&index=0&id=c0663118&scoped=true&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0663118"]])

export default __exports__